import { useCallback, useContext } from 'react';
import STORE from '../../../../../../store';
import isDefined from '../../../../../../isDefined';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import GoalsContext from '../../../../../../contexts/GoalsContext';
import { FindAndReplace } from '../../types';

const useFindAndReplaceGoals = () => {
  const { goals } = useContext(GoalsContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const replaceGoals = useCallback(
    async (metricReceipt: FindAndReplace.MetricReceipt) => {
      const { findMetricId, replaceMetricId } = metricReceipt;
      const affectedGoalIds = metricReceipt?.affectedContentIds.goals;

      if (!affectedGoalIds?.length) {
        return;
      }

      const goalPromises = affectedGoalIds
        .map((goalId) => goals.find((g) => g.id === goalId))
        .filter(isDefined)
        .map((goal) => {
          const newGoal = {
            ...goal,
            metricId:
              goal.metricId === findMetricId ? replaceMetricId : goal.metricId,
          };
          return STORE.visualisations
            .getGoalsRef({ accountId: selectedAccountId })
            .doc(goal.id)
            .set(newGoal);
        });

      await Promise.all(goalPromises);
    },
    [goals, selectedAccountId],
  );

  return replaceGoals;
};

export default useFindAndReplaceGoals;
